import type {PropsWithChildren} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './item.module.css';

type Props = {
  readonly href?: string;
} & PropsWithChildren;

export function BreadCrumbItem({href, children}: Props) {
  if (href === undefined)
    return (
      <li
        className={clsx(
          styles.item,
          isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
        )}
      >
        <span className={styles.wrapper}>{children}</span>
      </li>
    );

  return (
    <li
      className={clsx(
        styles.item,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      <a className={styles.link} href={href}>
        {children}
      </a>
      <ArrowIcon />
    </li>
  );
}

function ArrowIcon() {
  return (
    <svg
      width='7'
      height='14'
      viewBox='0 0 7 14'
      fill='none'
      aria-hidden='true'
    >
      <g clipPath='url(#clip0_851_159977)'>
        <path
          d='M0.5 1L6.5 7L0.5 13'
          stroke='black'
          strokeOpacity='0.2'
          strokeWidth='0.9975'
          strokeMiterlimit='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_851_159977'>
          <rect
            width='7'
            height='13'
            fill='white'
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
